<template>
  <div id="origin" v-clickoutside="closePanel" class="origin">
    <input
      :ref="`${searchKeysType}Input`"
      v-model="text"
      :class="{ 'active-border': true, 'input-error': inputErrorShow, 'input-disabled': disabled }"
      :placeholder="placeholderShow"
      :style="{ width: width + 'px' }"
      :disabled="disabled"
      @focus="focusInput"
      @blur="blurInput"
    >
    <el-collapse-transition>
      <div
        v-if="panelShow"
        :class="{ 'by-panel': true,}"
        @mouseenter="panelOpen = true"
        @mouseleave="panelOpen = false"
      >
        <div class="load-title">
          <span>┃</span>
          <span>Where are you shipping? </span>
        </div>
        <div class="load-tab">
          <div
            v-for="(item,index) in tabList"
            :key="index"
            :class="['tab-class',{'active':selectNumber == index}]"
            @click="clickType(item,index)"
          >
            {{ item.title }}
          </div>
        </div>
        <UnitType v-show="selectNumber == 0" ref="UnitType" @next="unitSuccess" />
        <TotalShipment v-show="selectNumber == 1" ref="TotalShipment" @next="totalSuccess" />

      </div>
    </el-collapse-transition>

  </div>
</template>

<script>
import TotalShipment from './Calculate/totalShipment.vue'
import UnitType from './Calculate/unitType.vue'
export default {
  name: 'Origin',
  components: {
    // 组件的引用
    TotalShipment,
    UnitType
  },
  props: {
    // 父辈向子辈传参
    disabled: {
      // 禁用输入
      type: Boolean,
      default: false
    },
    searchKeysType: {
      // 搜索关键词
      type: String,
      required: true,
      default: 'City'
    },
    width: {
      type: String,
      required: false,
      default: '200'
    },
    placeholder: {
      // 输入框默认提示
      // type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      text: '', // 输入框显示文字
      panelShow: false,
      inputErrorShow: false,
      panelOpen: false,
      placeholderShow: 'Where are you shipping from?', // 输入框默认显示提示文字
      tabList: [{
        title: 'Calculate by unit type'
      },
      {
        title: 'Calculate by total shipment'
      }
      ],
      selectNumber: 0,
      totalInfo: {},
      volumeList: [{
        packageType: 0,
        weightUnit: 'KG',
        volumeUnit: 'CM',
        quantity: 1,
        weight: '',
        length: '',
        width: '',
        height: '',
        palletType: '4',
        openFlag: true
      }],
      originTotalInfo: {
        quantity: '',
        volume: '',
        weight: '',
        volumeUnit: 'CBM',
        weightUnit: 'KG'
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
    placeholder: {
      handler(val) {
        // console.log('placeholder', val);
        this.placeholderShow = val
      },
      // deep: true,
      immediate: true
    },
    panelShow(val) {
      // 获取组件的聚焦状态
      this.$emit('getFocusStatus', val)
    }
  },
  created() {
    // 实例被创建之后执行代码

  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data, selectNumber) {
      if (selectNumber) {
        this.selectNumber = selectNumber
        if (this.selectNumber === 1) {
          this.originTotalInfo = data
          this.text = this.originTotalInfo.quantity + ' Unit | Total: ' + this.originTotalInfo.volume +
							' cbm, ' + this.originTotalInfo.weight + ' kg'
          this.$emit('next', data)
        }
      }
    },
    // 打开下拉列表
    focusInput() {
      this.panelShow = true
      // 获取选中
      if (this.selectNumber === 1) {
        this.$nextTick(() => {
          this.$refs.TotalShipment.init(this.originTotalInfo)
        })
      } else if (this.selectNumber === 0) {
        this.$nextTick(() => {
          this.$refs.UnitType.init(this.volumeList)
        })
      }
    },
    // 输入框失去焦点
    blurInput() {
      this.placeholderShow = this.placeholder
      if (!this.panelOpen) {
        this.closePanel(1)
      }
    },
    // 关闭下拉列表
    closePanel(val) {
      this.panelShow = false
      if (val == 1) {
        this.$emit('blur')
      }
    },
    clickType(item, index) {
      this.selectNumber = index
    },
    unitSuccess(totalInfo, volumeList) {
      this.totalInfo = totalInfo
      this.volumeList = volumeList
      this.text = totalInfo.quantity + ' Unit | Total: ' + totalInfo.volume + ' cbm, ' + totalInfo.weight + ' kg'
      this.$emit('next', totalInfo)
      this.closePanel(1)
    },
    totalSuccess(totalInfo, originInfo) {
      this.totalInfo = totalInfo
      this.originTotalInfo = originInfo
      this.text = totalInfo.quantity + ' Unit | Total: ' + totalInfo.volume + ' cbm, ' + totalInfo.weight + ' kg'
      this.$emit('next', totalInfo)
      this.closePanel(1)
    }
  }
}
</script>
<style scoped lang='scss'>
	.origin {
		input {
			outline: none;
			border: none;
			height: 32px;
			background: transparent;
			position: relative;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 550;
			color: #333333;
			line-height: 22px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		input::-webkit-input-placeholder {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #aaaaaa;
			line-height: 22px;
		}

		.input-error {
			&::-webkit-input-placeholder {
				color: #d83f3f;
			}
		}

		.input-disabled {
			color: #777;
		}

		.by-panel {
			position: absolute;
			left: 0px;
			top: 83px;
			z-index: 10;
			width: 792px;
			height: auto; //360px;
			background: #FFFFFF;
			box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid rgba(221, 221, 221, 0.56);

			.load-title {
				height: 32px;
				text-align: left;
				margin: 8px 16px;

				span:nth-of-type(1) {
					color: #E95506;
					margin-right: 10px;
				}

				span:nth-of-type(2) {
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
				}
			}

			.load-tab {
				width: 426px;
				height: 48px;
				background: #EFF1F5;
				border-radius: 8px;
				display: flex;
				align-items: center;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;
				margin: 0 16px;
				padding: 8px;

				.tab-class {
					margin-right: 16px;
					cursor: pointer;
				}

				.active {
					height: 32px;
					line-height: 32px;
					background: #FFFFFF;
					border-radius: 6px;
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #E95506 !important;
					padding: 0 8px;
				}

			}

		}
	}
</style>
